import {
  Box,
  Flex,
  Image,
  Progress,
  VStack,
  Text,
  useStyleConfig,
} from '@chakra-ui/react'
import { ContainerBase } from '@/components/containers/ContainerBase'

interface IProps {
  article: any
  loading: boolean
}

export const ResearchArticle = ({ article, loading }: IProps) => {
  const styles = useStyleConfig('Box', { variant: 'white' })

  return (
    <>
      <Box __css={styles}>
        {loading && <Progress size="xs" isIndeterminate colorScheme="brand" />}
        {article && (
          <ContainerBase py="100px">
            <Flex
              flexDirection={{ base: 'column', md: 'row' }}
              gridGap={{ base: '', md: '100px' }}
            >
              <VStack
                display={{ base: 'block', md: 'none' }}
                width="100%"
                alignItems="flex-start"
                mb="30px"
              >
                <Text
                  display={{ base: 'block', md: 'none' }}
                  color="brand.600"
                  fontSize="13px"
                  fontWeight="bold"
                >
                  {article?.excerpt}
                </Text>
                <Text
                  display={{ base: 'block', md: 'none' }}
                  fontSize={'32px'}
                  fontWeight="bold"
                  lineHeight="normal"
                >
                  {article?.title}
                </Text>
              </VStack>
              <Box
                flexBasis={{ md: '40%' }}
                flexShrink="0"
                maxHeight={{ md: '575px' }}
              >
                <Image
                  src={article?.feature_image}
                  width="100%"
                  height="100%"
                  objectFit="contain"
                />
              </Box>
              <Box mt={{ base: '30px', md: '0' }}>
                <VStack alignItems="flex-start" spacing="20px">
                  <Text
                    display={{ base: 'none', md: 'block' }}
                    color="brand.600"
                    fontSize="13px"
                    fontWeight="bold"
                  >
                    {article?.excerpt}
                  </Text>
                  <Text
                    display={{ base: 'none', md: 'block' }}
                    fontSize={{ base: '', md: '32px' }}
                    fontWeight="bold"
                    lineHeight="normal"
                  >
                    {article?.title}
                  </Text>
                  {article?.access && (
                    <Box className="article">
                      <Box
                        fontSize={{
                          base: '14px !important',
                          md: '16px !important',
                        }}
                        dangerouslySetInnerHTML={{
                          __html: article?.html,
                        }}
                      />
                    </Box>
                  )}
                </VStack>
              </Box>
            </Flex>
          </ContainerBase>
        )}
      </Box>
    </>
  )
}
